import {Component, Host, h, Prop} from "@stencil/core";
import {store} from "../stores/notification-handler-store";

/** Notification bell component to display new notifications */
@Component({
	tag: "uxn-notification-bell",
	styleUrl: "notification-bell.scss",
	shadow: false,
})
export class NotificationBell {
	#baseClass: string = "uxn-notification-bell";

	/** environment for fetching data  */
	@Prop() env: string = "prod";

	/** debugging */
	@Prop() debug: boolean = false;

	render() {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		return (
			<Host class={this.#baseClass}>
				<div class="uxn-notification-bell__content">
					{store.get("token") !== null && store.get("counter") > 0 ? <ux-notification-bell counter={store.get("counter")} /> : <ux-notification-bell />}
				</div>
			</Host>
		);
	}
}
